import { inheritsLoose as _inheritsLoose } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Otp from '@piconetworks/pkg-field-otp';
import PhoneField from './PhoneField.js';
import styles from './scss/TextSignup.module.scss.js';

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);
  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    console.log('getDerivedStateFromError', error);
    return {
      hasError: true
    };
  };
  function ErrorBoundary(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      hasError: false
    };
    return _this;
  }
  var _proto = ErrorBoundary.prototype;
  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
    console.error(error.message, errorInfo);
  };
  _proto.render = function render() {
    var hasError = this.state.hasError;
    var _this$props = this.props,
      children = _this$props.children,
      _this$props$RenderErr = _this$props.RenderError,
      RenderError = _this$props$RenderErr === void 0 ? function () {
        return /*#__PURE__*/React.createElement("div", {
          className: "errorBoundaree"
        });
      } : _this$props$RenderErr;
    if (hasError) {
      return /*#__PURE__*/React.createElement(RenderError, null);
    }
    return children;
  };
  return ErrorBoundary;
}(React.Component);
var TextSignup = function TextSignup(_temp) {
  var _cx;
  var _ref = _temp === void 0 ? {} : _temp,
    checkPhone = _ref.checkPhone,
    confirmCode = _ref.confirmCode,
    contrastColor = _ref.contrastColor,
    fieldContainerProps = _ref.fieldContainerProps,
    isReturningUser = _ref.isReturningUser,
    _ref$linkColor = _ref.linkColor,
    linkColor = _ref$linkColor === void 0 ? '' : _ref$linkColor,
    oneTimeCodeError = _ref.oneTimeCodeError,
    _ref$oneTimeCodeSent = _ref.oneTimeCodeSent,
    oneTimeCodeSent = _ref$oneTimeCodeSent === void 0 ? false : _ref$oneTimeCodeSent,
    _ref$onSubmitCallback = _ref.onSubmitCallback,
    onSubmitCallback = _ref$onSubmitCallback === void 0 ? function () {} : _ref$onSubmitCallback,
    phoneNumber = _ref.phoneNumber,
    _ref$previewMode = _ref.previewMode,
    previewMode = _ref$previewMode === void 0 ? false : _ref$previewMode,
    username = _ref.username,
    userPhoneMismatchError = _ref.userPhoneMismatchError,
    _ref$isCustomFieldsVa = _ref.isCustomFieldsValid,
    isCustomFieldsValid = _ref$isCustomFieldsVa === void 0 ? true : _ref$isCustomFieldsVa,
    _ref$values = _ref.values,
    values = _ref$values === void 0 ? {} : _ref$values,
    setFlow = _ref.setFlow,
    defaultType = _ref.defaultType,
    _ref$resetOneTimeCode = _ref.resetOneTimeCode,
    resetOneTimeCode = _ref$resetOneTimeCode === void 0 ? function () {} : _ref$resetOneTimeCode,
    errorMessage = _ref.errorMessage,
    getErrorText = _ref.getErrorText,
    loginPhone = _ref.loginPhone,
    isAuthenticated = _ref.isAuthenticated;
  var _useState = useState(!loginPhone),
    enterPhone = _useState[0],
    setEnterPhone = _useState[1];
  useEffect(function () {
    if (oneTimeCodeSent) {
      setEnterPhone(false);
    }
  }, [oneTimeCodeSent]);
  var requestNewCode = function requestNewCode() {
    setEnterPhone(true);
    resetOneTimeCode();
  };
  var enterOTP = function enterOTP() {
    setEnterPhone(false);
  };
  var showPhoneInput = !!userPhoneMismatchError || previewMode || enterPhone;
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("section", {
    className: cx((_cx = {}, _cx[styles.isPreview] = previewMode, _cx)),
    "data-testid": "sms-signup"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "" + (showPhoneInput ? 'block' : 'none')
    }
  }, /*#__PURE__*/React.createElement(PhoneField, {
    checkPhone: checkPhone,
    contrastColor: contrastColor,
    enterOTP: enterOTP,
    enterPhone: enterPhone,
    fieldContainerProps: fieldContainerProps,
    isReturningUser: isReturningUser,
    oneTimeCodeError: oneTimeCodeError,
    onSubmitCallback: onSubmitCallback,
    previewMode: previewMode,
    userPhoneMismatchError: userPhoneMismatchError,
    isCustomFieldsValid: isCustomFieldsValid,
    setFlow: setFlow,
    values: values,
    errorMessage: errorMessage,
    getErrorText: getErrorText,
    isAuthenticated: isAuthenticated
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "" + (showPhoneInput ? 'none' : 'block')
    }
  }, /*#__PURE__*/React.createElement(Otp, {
    checkPhone: checkPhone,
    confirmCode: confirmCode,
    contrastColor: contrastColor,
    enterOTP: enterOTP,
    fieldContainerProps: fieldContainerProps,
    linkColor: linkColor,
    oneTimeCodeError: oneTimeCodeError,
    oneTimeCodeSent: oneTimeCodeSent,
    phoneNumber: phoneNumber,
    requestNewCode: requestNewCode,
    customProperties: defaultType === null || defaultType === void 0 ? void 0 : defaultType.customFields,
    newsletters: defaultType === null || defaultType === void 0 ? void 0 : defaultType.newsletters
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.terms
  }, "By clicking \u201CContinue,\u201D you agree to ", /*#__PURE__*/React.createElement("a", {
    href: "https://hype.co/terms/user-agreement",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Hype\u2019s Terms"), ' ', "and acknowledge the ", /*#__PURE__*/React.createElement("a", {
    href: "https://hype.co/terms/privacy-policy",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Privacy Policy"), ".", ' ', "You also agree that ", username, " may contact the phone number provided with marketing materials by text message or phone (including via an automated system). Consent is not a condition of purchase. Message & data rates may apply.")))));
};
TextSignup.propTypes = {
  checkPhone: PropTypes.func,
  confirmCode: PropTypes.func,
  contrastColor: PropTypes.string,
  defaultType: PropTypes.object,
  description: PropTypes.string,
  errorMessage: PropTypes.string,
  fieldContainerProps: PropTypes.any,
  getErrorText: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  isCustomFieldsValid: PropTypes.bool,
  isReturningUser: PropTypes.bool,
  linkColor: PropTypes.string,
  loginPhone: PropTypes.any,
  oneTimeCodeError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  oneTimeCodeSent: PropTypes.bool,
  onSubmitCallback: PropTypes.func,
  phoneNumber: PropTypes.string,
  previewMode: PropTypes.bool,
  resetOneTimeCode: PropTypes.func,
  setFlow: PropTypes.func,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  username: PropTypes.string,
  userPhoneMismatchError: PropTypes.string,
  values: PropTypes.object
};
var MemoizedTextSignup = /*#__PURE__*/React.memo(TextSignup);
MemoizedTextSignup.displayName = 'FieldSignupTextSignup';
var TextSignup$1 = MemoizedTextSignup;

export { TextSignup$1 as default };
//# sourceMappingURL=index.js.map
